<template>
  <div class="container basic-info">
    <input @keydown.enter="confirmEmail" id="email"
      type="email" placeholder="Email" v-model="email" />
    <div v-show="!isWina && !isUrlSource" class="referred-section">
      <div>¿Te recomendó alguien?</div>
      <div>
        <span :class="{ 'active': !referred, 'referred-options': true }">No</span>
        <label class="switch">
          <input type="checkbox" v-model="referred">
          <span class="slider round"></span>
        </label>
        <span :class="{ 'active': referred, 'referred-options': true }">Si</span>
      </div>
    </div>
    <input v-show="referred && !isWina && !isUrlSource"
      type="text" placeholder="Referido Por" v-model="referredBy" />
    <transition name="fade">
      <div v-if="showCodeField" class="code-field-container">
        <p>Te enviamos un email a "{{emailSent}}" con un código de confirmación. Escribilo aquí:</p>
        <input id="confirmation-code" type="text" v-model="code" :disabled="codeFieldDisabled" />
        <p class="aclaration-text">
          ¿No lo recibiste? ¿Chequeaste el correo no deseado? <a href="#" @click.prevent="confirmEmail">Enviar de nuevo</a>
        </p>
      </div>
    </transition>
      <button v-if="!showCodeField" @click="confirmEmail">Confirmá Tu Email</button>
      <p v-if="!showCodeField" style="margin-top: 5px; color: #999; font-size: 11px;">Este sitio está protegido por reCAPTCHA y Google, las
      <a href="https://policies.google.com/privacy">Políticas de Privacidad</a> y
      <a href="https://policies.google.com/terms">Terminos</a> de estos aplican</p>
    <transition name="fade">
      <p class="error-message" v-if="error">{{error}}</p>
      <p class="error-message aclaration-text" v-if="error">
        <a href="#" @click.prevent="confirmEmail">Enviar de nuevo</a>
      </p>
    </transition>
    <p class="login-text">¿Ya tenés una cuenta? <a target="_blank" href="https://acceso.alfyinversiones.com.ar">Ingresá</a></p>
  </div>
</template>

<script>
import axios from 'axios';
import CONSTANTS from '@/constants';
import qs from 'qs';

function isEmail(email) {
  // eslint-disable-next-line
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export default {
  name: 'basic-info',
  props: {
    token: String,
    loggedIn: Boolean,
    screen: Number,
  },
  data() {
    return {
      email: '',
      emailSent: '',
      code: '',
      error: null,
      showCodeField: false,
      codeFieldDisabled: false,
      referred: false,
      isWina: false,
      isUrlSource: false,
      referredBy: '',
    };
  },
  methods: {
    confirmEmail(e) {
      this.code = '';
      this.error = '';
      if (e.type === 'keydown' && e.keyCode === undefined) {
        return;
      }
      if (!this.email) {
        this.error = 'El campo email no puede estar vacío';
        return;
      }
      if (!isEmail(this.email)) {
        this.error = 'El campo email debe contener un correo electrónico';
        return;
      }
      if (this.$recaptcha === undefined) {
        this.error = 'Verificá que tu navegador no bloquee el servicio Recaptcha, sino utilizá otro';
        return;
      }
      this.setIsLoading(true);
      this.$recaptcha('login')
        .then((/* recaptchaCode */) => {
          // console.log(recaptchaCode);
          this.sendToken();
        })
        .catch((err) => {
          this.setIsLoading(false);
          // console.log('Error Recaptcha', err);
          this.$rollbar.error(err);
          let email = '';
          if (localStorage.getItem('email')) {
            email = JSON.parse(localStorage.getItem('email'));
          }
          this.$rollbar.info('confirmEmail', { loggedIn: this.$props.loggedIn, email });
          this.error = 'Ocurrió un error inesperado de Recaptcha. Intentá Nuevamente';
        });
    },
    sendToken() {
      localStorage.setItem('email', JSON.stringify(this.email));
      const data = { email: this.email };
      const options = {
        method: 'POST',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: qs.stringify(data),
        url: `${CONSTANTS.BACKEND_URL}/auth/email/`,
      };
      axios(options)
        .then((/* result */) => {
          // console.log(result);
          this.emailSent = this.email;
          this.showCodeField = true;
          window.gtag('event', 'submit', {
            event_category: 'email_paso1',
            event_label: this.emailSent,
          });
          this.setIsLoading(false);
        })
        .catch((error) => {
          this.setIsLoading(false);
          this.$rollbar.error(error);
          let email = '';
          if (localStorage.getItem('email')) {
            email = JSON.parse(localStorage.getItem('email'));
          }
          this.$rollbar.info('sendToken', { loggedIn: this.$props.loggedIn, email });
          this.error = 'Ocurrió un error inesperado. Intente Nuevamente';
        });
    },
    setIsLoading(loading = true) {
      this.$emit('is-loading', loading);
    },
    useToken(code) {
      const data = { token: code };
      const options = {
        method: 'POST',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: qs.stringify(data),
        url: `${CONSTANTS.BACKEND_URL}/callback/auth/`,
      };
      axios(options)
        .then((result) => {
          // console.log(result);
          let email = '';
          if (localStorage.getItem('email')) {
            email = JSON.parse(localStorage.getItem('email'));
          }

          this.$emit('update-user-token', result.data.token);
          const dataReferral = JSON.stringify({
            was_referred: this.referred,
            chosen_referral: this.referredBy,
          });
          const optionsUserProfile = {
            method: 'POST',
            data: dataReferral,
            headers: { 'Content-Type': 'application/json', Authorization: `Token ${result.data.token}` },
            url: `${CONSTANTS.BACKEND_URL}${CONSTANTS.API_URL}/user/profile/`,
          };
          // console.log(optionsUserProfile);
          axios(optionsUserProfile)
            .then((resultUserProfile) => {
              window.gtag('event', 'submit', {
                event_category: 'paso1',
                event_label: email,
              });
              this.codeFieldDisabled = !this.codeFieldDisabled;
              const user = resultUserProfile.data;
              // console.log(resultUserProfile.data);
              this.$emit('update-user', user);
              this.$emit('advance-screen');
            })
            .catch((error) => {
              // console.error(error);
              this.$rollbar.error(error);
              this.$rollbar.info('uploadUserData', { loggedIn: this.$props.loggedIn, email });
            });
        })
        .catch((error) => {
          this.$rollbar.error(error);
          let email = '';
          if (localStorage.getItem('email')) {
            email = JSON.parse(localStorage.getItem('email'));
          }
          this.$rollbar.info('Login', { email });
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            /* console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers); */
            if (error.response.data.token[0] === "The token you entered isn't valid.") {
              this.error = 'El código ingresado ha expirado o no es correcto';
            } else {
              this.error = 'Ocurrió un error inesperado. Intente Nuevamente';
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            // console.log(error.request);
            this.error = 'Intente Nuevamente, el servidor no respondió correctamente';
          }
          this.setIsLoading(false);
          this.codeFieldDisabled = !this.codeFieldDisabled;
        });
    },
  },
  watch: {
    code(newCode) {
      if (newCode.length === 6) {
        this.setIsLoading();
        this.codeFieldDisabled = !this.codeFieldDisabled;
        this.useToken(newCode);
      }
    },
  },
  mounted() {
    /* We redirect to log in screen if not logged in */
    if (!this.$props.loggedIn) this.$router.push({ name: 'basic-info' });
    if (this.$props.screen !== 0) this.$emit('advance-screen-protect', this.$props.screen);
    window.gtag('config', 'UA-140392151-1', {
      page_title: 'paso1',
      page_path: '/',
    });
    if (this.$route.query.byd) {
      let usedLinkToken = 0;
      if (localStorage.getItem('usedLinkToken')) {
        usedLinkToken = JSON.parse(localStorage.getItem('usedLinkToken'));
      }
      if (usedLinkToken < 8) {
        localStorage.setItem('usedLinkToken', usedLinkToken + 1);
        this.useToken(this.$route.query.byd);
      }
    } else if (this.$route.query.utm_source && this.$route.query.utm_source.toLowerCase().match(/^prod-./)) {
      this.isUrlSource = true;
      this.referred = true;
      this.referredBy = this.$route.query.utm_source.toLowerCase().replace(/^(prod-)/, '');
      if (this.referredBy.startsWith('wina')) {
        this.isWina = true;
      }
    }
  },
};
</script>

<style lang="scss">
@import '../assets/css/variables.scss';

#confirmation-code {
  background-color: hsl(196, 14%, 93%);
}
.code-field-container {
  text-align: left;
  .aclaration-text {
    font-size: 12px;
  }
  input {
    margin: 16px auto 2px;
  }
}
.login-text {
  margin-top: 54px;
  font-size: 13px;
}
.referred-section .referred-options.active {
  font-weight: 800;
}
.referred-section {
  text-align: left;
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
}

@media screen and (min-width: $break-sm) {
  .basic-info button {
    width: auto;
    padding: 10px 32px;
  }
}
</style>
